import clsx from 'clsx';
import React from 'react';

import { subscribe_promotion_path } from '../../routes';
import { DEFAULT_ANNUAL_OFFER_CODE, DEFAULT_ANNUAL_PRICE } from '../../src/constants';
import { Button } from '../BaseUI';
import { Benefits } from '../shared';
import styles from './styles.module.scss';

const ValueBox = () => {
  return (
    <div className={styles.valueBox} data-test="value-box">
      <div className={styles.topBar}></div>
      <div className={clsx(styles.column, styles.leftColumn)}>
        <div className={styles.highlight}>Special Offer</div>
        <h2 className={styles.tagline}>
          The coverage today&rsquo;s top tech, business and media executives can&rsquo;t live
          without.
        </h2>
      </div>
      <div className={styles.column}>
        <h3 className={styles.annual}>Annual</h3>
        <div className={styles.price}>${DEFAULT_ANNUAL_PRICE}/Year</div>
        <Button
          variant="primary"
          rounded="full"
          href={subscribe_promotion_path({ offer: DEFAULT_ANNUAL_OFFER_CODE })}
        >
          Subscribe
        </Button>
        <Benefits
          benefits={[
            'Read stories you won’t find anywhere else',
            'Subscribe to our suite of newsletters',
            'Access to Profiles, Directory and Forum',
            'Read on the go with The Information app',
          ]}
          shrinkTextOnMobile
          topMargin="Medium"
        />
      </div>
      <div className={styles.valueTag}>Best Value</div>
    </div>
  );
};

export default ValueBox;
